export class PosicionesConstants {
  public readonly ARRIBA = 'Arriba';
  public readonly ABAJO = 'Abajo';
  public readonly CENTRO = 'Centro';

  constructor() {
  }
}
